var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleTips"},[(_vm.listData.length)?[_c('div',[_vm._v("(")]),_c('TitleTipsItem',{attrs:{"listData":_vm.listData}}),_c('div',[_vm._v(")")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }